import { render, staticRenderFns } from "./Quarantine-Transfer.vue?vue&type=template&id=7f240c98"
import script from "./Quarantine-Transfer.vue?vue&type=script&lang=js"
export * from "./Quarantine-Transfer.vue?vue&type=script&lang=js"
import style0 from "./Quarantine-Transfer.vue?vue&type=style&index=0&id=7f240c98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports